import React from 'react';

// HoC
import { withStyles } from '@material-ui/core/styles';

// Components

import moment from 'moment';
import { stableSort, getSorting } from 'common/utilities/stableSort';
// MuiComponents
import {
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
  TablePagination,
} from '@material-ui/core';

// Icons
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  FileCopy as DuplicateIcon,
} from '@material-ui/icons';

const styles = {
  nameCell: {
    maxWidth: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  actionCell: {
    width: 200,
  },
};

// Table Header Definitions
const rows = [
  { id: 'name', numeric: false, label: 'Name' },
  { id: 'updatedAt', numeric: false, label: 'Updated On' },
  { id: 'createdAt', numeric: true, label: 'Created On' },
];

class PermissionPresetList extends React.Component {
  state = {
    order: 'asc',
    orderBy: 'name',
    page: 0,
    rowsPerPage: 10,
  };

  // The sort & pagination functions are refered from Material-UI tables demo
  createSortHandler = property => event => {
    this.handleRequestSort(event, property);
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  collectionToRender = () => {
    const { collection = [] } = this.props;
    const { order, orderBy, page, rowsPerPage } = this.state;

    return stableSort(collection, getSorting(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    );
  };

  render() {
    const {
      classes,
      onEdit,
      onDelete,
      onCopy,
      collection = [],
      blockCopy,
    } = this.props;
    const { order, orderBy, page, rowsPerPage } = this.state;
    const processedCollection = this.collectionToRender();

    return (
      <Paper elevation={0}>
        <Table data-test-id="PermissionPresetList-root">
          <TableHead>
            <TableRow>
              {rows.map(
                row => (
                  <TableCell
                    key={row.id}
                    sortDirection={orderBy === row.id ? order : false}
                    data-test-id={`PermissionPresetList-header-${row.id}`}
                  >
                    <TableSortLabel
                      active={orderBy === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id)}
                      data-test-id={`PermissionPresetList-sort-${row.id}`}
                    >
                      {row.label}
                    </TableSortLabel>
                  </TableCell>
                ),
                this,
              )}
              <TableCell
                align="center"
                data-test-id="PermissionPresetList-header-actions"
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {processedCollection.map(preset => (
              <TableRow
                key={preset.id}
                data-test-id={`PermissionPresetList-tableRow-${preset.id}`}
              >
                <TableCell
                  data-test-id={`PermissionPresetList-name-${preset.id}`}
                >
                  <Typography variant="subtitle1" className={classes.nameCell}>
                    {preset.name}
                  </Typography>
                </TableCell>
                <TableCell
                  data-test-id={`PermissionPresetList-updatedAt-${preset.id}`}
                >
                  {moment(preset.updatedAt).format('MMMM DD, YYYY')}
                </TableCell>
                <TableCell
                  data-test-id={`PermissionPresetList-createdAt-${preset.id}`}
                >
                  {moment(preset.createdAt).format('MMMM DD, YYYY')}
                </TableCell>
                <TableCell className={classes.actionCell}>
                  <IconButton
                    onClick={onEdit(preset.id)}
                    data-test-id={`PermissionPresetList-edit-${preset.id}`}
                  >
                    <EditIcon />
                  </IconButton>
                  <Tooltip
                    title={`Duplicate ${preset.name}`}
                    data-test-id={`PermissionPresetList-duplicate-${preset.id}`}
                  >
                    <IconButton
                      onClick={onCopy(preset.id)}
                      disabled={blockCopy}
                    >
                      <DuplicateIcon />
                    </IconButton>
                  </Tooltip>
                  <IconButton
                    onClick={onDelete(preset.id)}
                    data-test-id={`PermissionPresetList-delete-${preset.id}`}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={collection.length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            'data-test-id': 'PermissionPresetList-pagination-select',
          }}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
            'data-test-id': 'PermissionPresetList-pagination-previous',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
            'data-test-id': 'PermissionPresetList-pagination-next',
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          data-test-id="PermissionPresetList-pagination-root"
        />
      </Paper>
    );
  }
}

export default withStyles(styles)(PermissionPresetList);
